<template>
  <div class="row" v-if="associatedEmployers.length > 0">
    <div class="col-md-12">
      <div class="alert alert-warning">
        This offering has been assigned to the following groups:
        <ul>
          <li v-for="e in associatedEmployers">{{ e.name }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {api} from "../../../../global/framework/api.js";

export default {
  name: "EmployersAssignedToPlanPool",
  props: {
    consultantId: {type: [Number], required: true},
    planPoolId: {type: [Number], required: true}
  },
  data() {
    return {
      associatedEmployers: []
    }
  },
  async mounted() {
    let data = await api.getDataWithTwoIds('MediatorPlan', this.consultantId, 'GetEmployersInPool', this.planPoolId);
    this.associatedEmployers = data;
  }
}
</script>

<style scoped>

</style>